import React from "react";
import { Button, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

export default function DeleteSection2({
  setModal,
  currentComponent,
  deleteComponent,
  itemType,
  modalTitle,
}) 
{
  
  return (
    <>
      <ModalHeader toggle={() => setModal((state) => !state)}>
        Delete {modalTitle}
      </ModalHeader>
      <ModalBody>
        Permanently delete position {itemType} <strong>{currentComponent?.position}</strong>?
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={() => {
            setModal((state) => !state);
            deleteComponent();
          }}
        >
          Yes
        </Button>
        <Button color="secondary" onClick={() => setModal((state) => !state)}>
          Cancel
        </Button>
      </ModalFooter>
    </>
  );
}
